import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Avatar, Box, Typography, Link } from "@talentpair/quantic";
import { useAuth } from "@talentpair/api";
import { env, londonLink } from "@talentpair/env";
import { mixpanelHelper } from "@talentpair/tracking";

const track = (action: string): void =>
  mixpanelHelper.track("Public Jobs CTA", { ctaType: "Results List", action });

const SignupCtaResult = (): React.ReactElement | null => {
  const { state, isLoggedIn } = useAuth();
  React.useEffect(() => {
    if (!isLoggedIn && state === "confirmed") track("Seen");
  }, [isLoggedIn, state]);

  // only show the cta to users that are not logged in
  return state === "checking" ? null : (
    <Box variant="row" className="mb3 p2" space={2}>
      <Avatar shape="rounded" fill="icon" Icon={SearchIcon} className="m2" />
      <Box variant="column">
        <Typography variant="body1" bold>
          No more jobs on our board match your search.
        </Typography>
        {isLoggedIn ? (
          <Typography variant="body2">Try updating your filter selections.</Typography>
        ) : (
          <ul className="sm-dots m0">
            <li>
              <Typography variant="body2">Try updating your filter selections, or</Typography>
            </li>
            <li>
              <Typography variant="body2">
                <Link
                  target="_self"
                  color="primary"
                  href={env.londonUrl(londonLink.authCandidateSignup())}
                  onClick={() => track("Clicked")}
                  data-testid="signupBtn"
                >
                  Create a Talentpair profile
                </Link>{" "}
                to receive personalized job matches.
              </Typography>
            </li>
          </ul>
        )}
      </Box>
    </Box>
  );
};

export default SignupCtaResult;
